import { DOCUMENT_FIELDS } from "@/constants";
import { getFieldError } from "@/utils/form";

export function getDocumentFieldError(key, value, validation, fieldValidity) {
  if (
    (key === DOCUMENT_FIELDS.NATIONALITY ||
      key === DOCUMENT_FIELDS.GENDER ||
      key === DOCUMENT_FIELDS.PERSONAL_CODE) &&
    fieldValidity
  ) {
    return undefined;
  }

  return getFieldError({ ...validation, value });
}
